
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { DashboardScreenSection } from "@/sections/DashboardScreenSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { CTASection } from "@/sections/CTASection";
import { useTheme } from "@/hooks/useTheme";
import { FigmaBackupTopScreen } from "@/sections/FigmaBackupTopScreen";
import { HowItWorks } from "@/sections/HowItWorks";
import { useInquiryForm } from "@/hooks/useInquiryForm";
import { FormSourceType } from "@/containers/InquiryForm";

const MiroBackup = () => {
  const { toggleInquiryForm } = useInquiryForm();
  const { t } = useTranslation();
  const { bp } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/miro-backup"
        ogImage="/images/miro-backup-og-image.jpg"
      />

      <FigmaBackupTopScreen
        title={t("page/miro-backup:title")}
        subtitle={t("page/miro-backup:subtitle")}
        src="/images/miro-backup-screen.png"
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.MIRO_BACKUP_INQUIRY)
        }
        buttonLabel={t("common:contactSales")}
        showVideo={false}
      />

      <CustomersLogosSection
        title={t("section/trustedBy:title")}
        customStyle={{
          borderBottom: "1px solid #E5EAF4",
        }}
      />

      <DashboardScreenSection
        title={t("page/miro-backup:section/storeDesign.title")}
        src="/images/miro-backup-versioning.png"
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "CMS-ICON",
            text: t(
              "page/miro-backup:section/storeDesign.elements.avoidLockIn",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "CMS-ICON",
            text: t(
              "page/miro-backup:section/storeDesign.elements.automatedConversion",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CMS-ICON",
            text: t(
              "page/miro-backup:section/storeDesign.elements.securedStorage",
            ),
          },
        ]}
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.MIRO_BACKUP_INQUIRY)
        }
        tryFreeLabel={t("common:contactSales")}
      />
      <DashboardScreenSection
        title={t("page/miro-backup:section/backupSection.title")}
        src="/images/miro-backup-storage.png"
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "CMS-ICON",
            text: t(
              "page/miro-backup:section/backupSection.elements.avoidLockIn",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "CMS-ICON",
            text: t(
              "page/miro-backup:section/backupSection.elements.automatedConversion",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CMS-ICON",
            text: t(
              "page/miro-backup:section/backupSection.elements.securedStorage",
            ),
          },
        ]}
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.MIRO_BACKUP_INQUIRY)
        }
        tryFreeLabel={t("common:contactSales")}
        wrapperStyles={{
          backgroundImage: "url('images/square-bg-big.png')",
          [bp.FROM_TABLET]: {
            padding: "40px 20px 120px",
          },
          nested: {
            "& > div": {
              borderTop: "none",
            },
          },
        }}
        rightSidedImage={false}
      />

      <HowItWorks
        title={t("page/miro-backup:section/howItWorks.title")}
        steps={[
          {
            id: "STEP#1",
            image: "/images/backup-authorize.png",
            text: t("page/miro-backup:section/howItWorks.steps.authorize"),
            rightSidedImage: true,
          },
          {
            id: "STEP#2",
            image: "/images/miro-backup-add-file.png",
            text: t("page/miro-backup:section/howItWorks.steps.insertFiles"),
          },
          {
            id: "STEP#3",
            image: "/images/miro-backup-success.png",
            text: t("page/miro-backup:section/howItWorks.steps.backup"),
            rightSidedImage: true,
          },
        ]}
        wrapperStyles={{
          backgroundImage: "url('images/square-bg-big.png')",
          nested: {
            "> div": {
              [bp.FROM_TABLET]: {
                padding: "100px 20px 80px",
              },
            },
          },
        }}
      />

      {/* <PricingSectionFigmaBackup /> */}

      <CTASection
        title={t("section/cta:titles.miroBackupPage")}
        buttonLabel={t("page/miro-backup:section/storeDesign.buttonLabel")}
        onButtonClick={() =>
          toggleInquiryForm(FormSourceType.MIRO_BACKUP_INQUIRY)
        }
        wrapperBgColor="#F8F9FE"
      />

      {/* <FigmaBackupFaqSection /> */}
    </>
  );
};

export default MiroBackup;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/miro-backup',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  